import Work1 from "../../assets/Images/Login.png";
import Work2 from "../../assets/Images/muble_ecmmerce.jpg";
import Work3 from "../../assets/Images/Thumbnail.png";
import Work4 from "../../assets/Images/Dribbble.png";

const Menu = [
    {
        id: 1,
        image: Work1,
        title: "Follow Me Dashboard",
        category: ["Full Stack", "React", "Node.js","Backend"],
        repositoryUrl: "https://github.com/anesszereg/Follow_me"
    },
    {
        id: 2,
        image: Work2,
        title: "landing page",
        category: ["Frontend", "Next.js" ,],
        url: "https://e-commerce.shop",
        repositoryUrl: "https://github.com/anesszereg/e-commerce"
    },
    {
        id: 3,
        image: Work3,
        title: "e-commerce Website",
        category: ["Full Stack", "React", "Node.js","Backend"],
        url: "https://",
        repositoryUrl: "https://github.com/anesszereg/binnovant-dashboard"
    },
    {
        id: 4,
        image: Work4,
        title: "Energy Drink App",
        category: ["Full Stack", "React Native", "Backend"],
        url: "https://",
        repositoryUrl: "https://github.com/anesszereg/code213-teaching-platform"
    }
];

export default Menu;
